import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';

import InputTextEditor from './input-text-editor';
import NiftyMarkdown from './nifty-markdown';

import IconInfo from '../icons/icon-info';

class DescriptionPane extends PureComponent {
    static defaultProps = {
        content: '',
        withIcon: true,
        withSave: true
    }

    state = {
        editing: !this.props.content,
        focus: false
    }

    handleBlur = () => {
        this.save();
    }

    handleSaveClick = () => {
        this.save();
    }

    handleSubmit = () => {
        this.editorCtrl && this.editorCtrl.blur();
    }

    handleFocus = () => {
        this.setState({
            editing: true,
            focus: true
        });
    }

    handlePaneClick = e => {
        if (!this.props.editable || e.target.tagName === 'A') {
            e.target.target = '_blank';
            return;
        }

        this.startEdit();
    }

    save() {
        const hasContent = this.editorCtrl.isPopulated();
        const content = this.editorCtrl?.getValue();

        this.setState({
            editing: !hasContent,
            focus: false
        });

        if (this.props.content === content) {
            return;
        }

        this.props.onChange && this.props.onChange(hasContent ? content : null);
    }

    startEdit() {
        this.setState({
            editing: true
        });
    }

    setCtrl = ctrl => this.editorCtrl = ctrl;

    get placeholder() {
        const { t } = this.props;
        return this.props.placeholder ?? t('Add a description');
    }

    get emptyPlaceholder() {
        const { t } = this.props;
        return this.props.placeholder ?? t('No description');
    }

    render() {
        const { t } = this.props;

        return (
            <div className={'description-pane' + (this.props.editable ? ' can-edit' : '') + (this.props.fieldLike ? ' field-like' : '')}>
                {
                    this.props.withIcon ? (
                        <div className="icon-holder">
                            <IconInfo />
                        </div>
                    ) : null
                }

                <div className={'description-body' + (this.state.focus ? ' description-focus' : '')}>
                    {
                        this.props.forceEdit || (this.state.editing && this.props.editable) ? (
                            <React.Fragment>
                                <div className="description-scrollable nice-scroll">
                                    <InputTextEditor
                                        id={this.props.id}
                                        value={this.props.content}
                                        placeholder={this.placeholder}
                                        provideController={this.setCtrl}
                                        enterToSubmit={false}
                                        autofocus={this.props.autofocus}
                                        users={this.props.users}
                                        onFocus={this.handleFocus}
                                        onBlur={this.handleBlur}
                                        onSubmit={this.handleSubmit}
                                        onChange={this.props.onEveryChange}
                                        onFilesPaste={this.props.onFilesPaste}
                                    />
                                </div>

                                {
                                    this.props.withSave ? <div className="description-save btn btn-success btn-xxsmall">{ t('Save') }</div> : null
                                }
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <div className="description-scrollable nice-scroll">
                                    <div className="pane" onClick={this.handlePaneClick}>
                                        <NiftyMarkdown placeholder={this.emptyPlaceholder}>{this.props.content}</NiftyMarkdown>
                                    </div>
                                </div>
                            </React.Fragment>
                        )
                    }
                </div>
            </div>
        )
    }
}

export default withTranslation('common')(DescriptionPane);
